import ActiveRecord from './active_record/base'

class AvailabilityTemplateShift extends ActiveRecord {
	static dates = ['2007-01-01', '2007-01-02', '2007-01-03', '2007-01-04', '2007-01-05', '2007-01-06', '2007-01-07']
	static tableName = 'availabilityTemplateShifts'

	static useHasTemplateShifts(userId) {
		return !!this.useWhere({user_id: userId}).length
	}
}

export default AvailabilityTemplateShift
